import React from "react";
import { Typewriter } from "react-simple-typewriter";

const TypeWriters = () => {
  return (
    <div class="h-subtitles">
      <div class="h-subtitle typing-subtitle">
        <p className=" text-lg border-secondary  ">
          <Typewriter
            words={[
              "Website Developer",
              "Frontend Engineer",
              "React Expert",
              "UI/UX Designer",
            ]}
            loop={true} // Set to true if you want to loop through the words continuously
            cursor
            cursorStyle="_"
            typeSpeed={100}
            deleteSpeed={50}
            delaySpeed={1000}
          />
        </p>
      </div>
    </div>
  );
};

export default TypeWriters;
